import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";
import Cards from "./VerifierCard";
import "../../styles/VerifierDashboard.css";
import { onAdminDocumentsChange, requestQuery } from "../../apis/firestoreDatabase";
import { useState, useEffect } from "react";
import { auth } from "../Firebase/Firebase";
import Loader from "../loader";

export default function EventsItem() {
  const [stateLoader, setStateLoader] = useState("block");
  const loadCompleteCallbackRef = useRef(null);
  
  const navigate = useNavigate();
  const [queryArr, changeQueries] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const handleInputOnChange = (event) => {
    //console.log(event.target.value)
    setInputValue(event.target.value);
  }
  const updateCards = async () => {
    try {
      // setStateLoader("block")
      const res = await requestQuery('verification.exam@mitwpu.edu.in');
      const temp = [];
      res.forEach((doc) => {
        temp.push({
          id: doc.id,
          data: doc.data()
        });
      });

      temp.sort((a,b)=>{
        const x=a.data.paymentStatus;
        const y=b.data.paymentStatus;

        const obj={
          "Not Verified":1,
          "Unpaid":2,
          "Paid":3
        }

        if(obj[x]>obj[y])
          return 1;
        else if(obj[x]<obj[y])
          return -1;
        else
          return 0;
      })

      console.log(temp);

      changeQueries(temp);
      setStateLoader("none")
    } catch (err) {
      // setStateLoader("none")
      console.log(err);
    }
  }

  useEffect(() => {
    updateCards();
    const unsub = onAdminDocumentsChange(updateCards);
    return unsub;
  }, []);

  useEffect(() => {
    if (stateLoader === 'none' && loadCompleteCallbackRef.current) {
      loadCompleteCallbackRef.current();
      loadCompleteCallbackRef.current = null;
    }
  }, [stateLoader]);

  async function logOut() {
    navigate("/");
    await auth.signOut();
  }

  return (
    (stateLoader === "block") ? <Loader /> :
      <div
        id="Verifier_Main_Item_Container_page">

        <div id="Verifier--Info-container" className="Verifier-flex">
          <div className="Verifier--details-container Verifier-flex">
            <div className="Verifier--Option-detail Verifier-start-flex">
              <p className="Info-property">Showing</p>
              <p className="Info-value">Payment Verification Requests</p>
            </div>

            <div className="Verifier--Option-detail Verifier-start-flex">
              <input
                type="search"
                className="Verifier-Info-search"
                placeholder="Search Here"
                value={inputValue}
                onChange={handleInputOnChange}
              />
            </div>
            
          </div>
       
          <div className="Verifier-Logout-btn-container Verifier-flex">
            <button className="btn btn-primary" onClick={logOut}>
              Logout
            </button>
          </div>
        </div>
        <div id="Main_Item_Container-Verifier">
          <div className="main_card_container mainHeaderContainer">
            <h2 className="heading"> Name </h2>
            <h2 className="heading"> PRN </h2>
            <h2 className="heading"> Payment Status </h2>
            <h2 className="heading"> Payment Date </h2>
            <h2 className="heading"> Payment Screenshot </h2>
            <h2 className="heading"> Verify Payment </h2>
          </div>
          {queryArr.map(({ data: element, id }, i) => {
             if (element.PRN.indexOf(inputValue) === -1 && element.candidateName.indexOf(inputValue) === -1) //search filter, name and prn
             return <></>

            return (
              <>
                <Cards
                  key={i}
                  id={id}
                  owner={element.owner}
                  name={element.candidateName}
                  prn={element.PRN}
                  paymentStatus={element.paymentStatus}
                  queryDate={element.submissionTimestamp?.toDate().toLocaleDateString('es-CL')}
                  color={i % 2 === 0 ? "rgba(255, 255, 255, 0.2)" : "rgba(0, 0, 0, 0.1)"}

                  setLoaderState={setStateLoader}
                  loadCompleteCallbackRef={loadCompleteCallbackRef}
                />
              </>
            );
          })}
        </div>
      </div>
  );
}
